import { ErrorResponse } from 'react-router-dom';
import { IPolicyDataSource, IPolicyInitialValues, IResponse } from '../types';
import { IUseHttpServiceProps } from '../services/type';
import { RequestMethods } from '../services/enum';
import { prepareFormData } from '../utils/functions';

export default class PolicyService {
  private readonly baseUrl: string = 'transportation-policies/policies/';

  constructor(
    private readonly executeService: <T>(
      args: IUseHttpServiceProps,
    ) => Promise<T | ErrorResponse | null>,
    private readonly parameters: string,
  ) {}

  async fetchData(): Promise<
    IResponse<IPolicyDataSource> | ErrorResponse | null
  > {
    return await this.executeService<IResponse<IPolicyDataSource>>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${this.parameters}`,
    });
  }

  async fetchItemById(
    id: number,
  ): Promise<IPolicyDataSource | ErrorResponse | null> {
    return await this.executeService<IPolicyDataSource>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async deleteItemById(id: number): Promise<unknown | ErrorResponse | null> {
    return await this.executeService<unknown>({
      method: RequestMethods.DELETE,
      url: `${this.baseUrl}${id}/`,
    });
  }

  async exportData(): Promise<{ download_url: string } | ErrorResponse | null> {
    return await this.executeService<{ download_url: string }>({
      method: RequestMethods.GET,
      url: `${this.baseUrl}export-excel/${this.parameters}`,
      contentType: 'multipart/form-data',
    });
  }

  async submitForm(
    values: IPolicyInitialValues,
    selectedItem?: IPolicyDataSource,
  ): Promise<IPolicyDataSource | ErrorResponse | null> {
    const formData = prepareFormData<IPolicyInitialValues>(values);

    const method = selectedItem ? RequestMethods.PUT : RequestMethods.POST;
    const url = selectedItem
      ? `${this.baseUrl}${selectedItem.id}/`
      : this.baseUrl;

    return await this.executeService<IPolicyDataSource>({
      method,
      url,
      data: formData,
      contentType: 'multipart/form-data',
    });
  }

  async uploadFiles(
    id: number,
    files: FileList,
  ): Promise<IPolicyDataSource | ErrorResponse | null> {
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append('upload_files', file);
    });

    return await this.executeService<IPolicyDataSource>({
      method: RequestMethods.POST,
      url: `${this.baseUrl}${id}/upload-files/`,
      data: formData,
      contentType: 'multipart/form-data',
    });
  }

  async deleteFile(
    id: number,
    fileId: number,
  ): Promise<IPolicyDataSource | ErrorResponse | null> {
    const formData = new FormData();
    formData.append('file_id', fileId.toString());

    return await this.executeService<IPolicyDataSource>({
      method: RequestMethods.POST,
      url: `${this.baseUrl}${id}/delete-file/`,
      data: formData,
      contentType: 'multipart/form-data',
    });
  }
}
